import { render, staticRenderFns } from "./ProjectGuests.vue?vue&type=template&id=af02566a&scoped=true"
import script from "./ProjectGuests.vue?vue&type=script&lang=ts"
export * from "./ProjectGuests.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGuests.vue?vue&type=style&index=0&id=af02566a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af02566a",
  null
  
)

export default component.exports